export interface IListConfing {
  id: string;
  visable: boolean;
  export: boolean;
  itemIndex?: number;
  groupIndex?: number;
  group?: number;
  required?:boolean
}

export const defaultConfigs = {
  listGlobal: [
    {
      id: "joint_name",
      visable: true,
      export: true,
      itemIndex: 0,
    },
    {
      id: "sectionName",
      visable: false,
      export: true,
      itemIndex: 1,
    },
    {
      id: "kks",
      visable: true,
      export: true,
      itemIndex: 2,
    },
    {
      id: "page",
      visable: true,
      export: true,
      itemIndex: 3,
    },
    {
      id: "joint_type",
      visable: true,
      export: true,
      itemIndex: 4,
    },
    {
      id: "element_type_1",
      visable: true,
      export: true,
      itemIndex: 5,
    },
    {
      id: "element_type_2",
      visable: true,
      export: true,
      itemIndex: 6,
    },
    {
      id: "diameter_1",
      visable: true,
      export: true,
      itemIndex: 7,
    },
    {
      id: "thickness_1",
      visable: true,
      export: true,
      itemIndex: 8,
    },
    {
      id: "material_1",
      visable: true,
      export: true,
      itemIndex: 9,
    },
    {
      id: "diameter_2",
      visable: true,
      export: true,
      itemIndex: 10,
    },
    {
      id: "thickness_2",
      visable: true,
      export: true,
      itemIndex: 11,
    },
    {
      id: "material_2",
      visable: true,
      export: true,
      itemIndex: 12,
    },
    {
      id: "welder",
      visable: true,
      export: true,
      itemIndex: 13,
    },
    {
      id: "welding_date",
      visable: true,
      export: true,
      itemIndex: 14,
    },
    {
      id: "melt_number_1",
      visable: true,
      export: true,
      itemIndex: 15,
    },
    {
      id: "melt_number_2",
      visable: true,
      export: true,
      itemIndex: 16,
    },
    {
      id: "vt_examination_number",
      visable: true,
      export: true,
      itemIndex: 17,
    },
    {
      id: "vt_examination_date",
      visable: true,
      export: true,
      itemIndex: 18,
    },
    {
      id: "vt_examination_result",
      visable: true,
      export: true,
      itemIndex: 19,
    },
    {
      id: "rt_examination_number",
      visable: true,
      export: true,
      itemIndex: 20,
    },
    {
      id: "rt_examination_date",
      visable: true,
      export: true,
      itemIndex: 21,
    },
    {
      id: "rt_examination_result",
      visable: true,
      export: true,
      itemIndex: 22,
    },
    {
      id: "pt_examination_number",
      visable: true,
      export: true,
      itemIndex: 23,
    },
    {
      id: "pt_examination_date",
      visable: true,
      export: true,
      itemIndex: 24,
    },
    {
      id: "pt_examination_result",
      visable: true,
      export: true,
      itemIndex: 25,
    },
    {
      id: "ut_examination_number",
      visable: true,
      export: true,
      itemIndex: 26,
    },
    {
      id: "ut_examination_date",
      visable: true,
      export: true,
      itemIndex: 27,
    },
    {
      id: "ut_examination_result",
      visable: true,
      export: true,
      itemIndex: 28,
    },
    {
      id: "mt_examination_number",
      visable: true,
      export: true,
      itemIndex: 29,
    },
    {
      id: "mt_examination_date",
      visable: true,
      export: true,
      itemIndex: 30,
    },
    {
      id: "mt_examination_result",
      visable: true,
      export: true,
      itemIndex: 31,
    },
  ],
  listSection: [
    {
      id: "joint_name",
      visable: true,
      export: true,
      itemIndex: 0,
    },
    {
      id: "sectionName",
      visable: false,
      export: true,
      itemIndex: 1,
    },
    {
      id: "kks",
      visable: true,
      export: true,
      itemIndex: 2,
    },
    {
      id: "page",
      visable: true,
      export: true,
      itemIndex: 3,
    },
    {
      id: "joint_type",
      visable: true,
      export: true,
      itemIndex: 4,
    },
    {
      id: "element_type_1",
      visable: true,
      export: true,
      itemIndex: 5,
    },
    {
      id: "element_type_2",
      visable: true,
      export: true,
      itemIndex: 6,
    },
    {
      id: "diameter_1",
      visable: true,
      export: true,
      itemIndex: 7,
    },
    {
      id: "thickness_1",
      visable: true,
      export: true,
      itemIndex: 8,
    },
    {
      id: "material_1",
      visable: true,
      export: true,
      itemIndex: 9,
    },
    {
      id: "diameter_2",
      visable: true,
      export: true,
      itemIndex: 10,
    },
    {
      id: "thickness_2",
      visable: true,
      export: true,
      itemIndex: 11,
    },
    {
      id: "material_2",
      visable: true,
      export: true,
      itemIndex: 12,
    },
    {
      id: "welder",
      visable: true,
      export: true,
      itemIndex: 13,
    },
    {
      id: "welding_date",
      visable: true,
      export: true,
      itemIndex: 14,
    },
    {
      id: "melt_number_1",
      visable: true,
      export: true,
      itemIndex: 15,
    },
    {
      id: "melt_number_2",
      visable: true,
      export: true,
      itemIndex: 16,
    },
  ],
  projectList: [
    {
      id: "projectName",
      visable: true,
      export: true,
      itemIndex: 0,
    },
    {
      id: "contractName",
      visable: true,
      export: true,
      itemIndex: 1,
    },
    {
      id: "author",
      visable: true,
      export: true,
      itemIndex: 2,
    },
    {
      id: "createdTime",
      visable: true,
      export: true,
      itemIndex: 3,
    },
    {
      id: "updatedTime",
      visable: true,
      export: true,
      itemIndex: 4,
    },
  ],
  sectionsList: [
    {
      id: "sectionName",
      visable: true,
      export: true,
      itemIndex: 0,
    },
    {
      id: "kks",
      visable: true,
      export: true,
      itemIndex: 1,
    },
    {
      id: "fileName",
      visable: true,
      export: true,
      itemIndex: 2,
    },
    {
      id: "status",
      visable: true,
      export: true,
      itemIndex: 3,
    },
    {
      id: "createdTime",
      visable: true,
      export: true,
      itemIndex: 4,
    },
    {
      id: "updatedTime",
      visable: true,
      export: true,
      itemIndex: 5,
    },
  ],
  addProjectForm: [
    {
      id: "projectName",
      visable: true,
      export: true,
      required: true,
      itemIndex: 0,
    },
    {
      id: "contractName",
      visable: true,
      export: true,
      required: true,
      itemIndex: 1,
    },
  ],
  addSectionForm: [
    {
      id: "sectionName",
      visable: true,
      export: true, 
      required: true,
      itemIndex: 0,
    },
    {
      id: "file",
      visable: true,
      export: true,
      required: true,
      itemIndex: 1,
    },
    {
      id: "revision",
      visable: true,
      export: true,
      required: true,
      itemIndex: 2,
    },
    {
      id: "kks",
      visable: true,
      export: true,
      required: true,
      itemIndex: 3,
    },
  ],
  jointDetail:[
    {
      id: "joint_name",
      visable: true,
      export: true,
      groupIndex: 0,
      group: 0
    },
    {
      id: "joint_type",
      visable: true,
      export: true,
      groupIndex: 1,
      group: 1
    },
    {
      id: "spoolID",
      visable: true,
      export: true,
      groupIndex: 2,
      group: 1
    },
    {
      id: "element_type_1",
      visable: true,
      export: true,
      groupIndex: 0,
      group: 2
    },
    {
      id: "element_type_2",
      visable: true,
      export: true,
      groupIndex: 1,
      group: 2
    },
    {
      id: "diameter_1",
      visable: true,
      export: true,
      groupIndex: 0,
      group: 3
    },
    {
      id: "diameter_2",
      visable: true,
      export: true,
      groupIndex: 1,
      group: 3
    },
    {
      id: "thickness_1",
      visable: true,
      export: true,
      groupIndex: 0,
      group: 4
    },
    {
      id: "thickness_2",
      visable: true,
      export: true,
      groupIndex: 1,
      group: 4
    },
    {
      id: "material_1",
      visable: true,
      export: true,
      groupIndex: 0,
      group: 5
    },
    {
      id: "material_2",
      visable: true,
      export: true,
      groupIndex: 1,
      group: 5
    },
    {
      id: "melt_number_1",
      visable: true,
      export: true,
      groupIndex: 0,
      group: 6
    },
    {
      id: "melt_number_2",
      visable: true,
      export: true,
      groupIndex: 1,
      group: 6
    },
    {
      id: "welder",
      visable: true,
      export: true,
      groupIndex: 0,
      group: 7
    },
    {
      id: "welding_date",
      visable: true,
      export: true,
      groupIndex: 0,
      group: 7
    },
    {
      id: "vt_examination_number",
      visable: true,
      export: true,
      groupIndex: 0,
      group: 8
    },
    {
      id: "vt_examination_date",
      visable: true,
      export: true,
      groupIndex: 1,
      group: 8
    },
    {
      id: "vt_examination_result",
      visable: true,
      export: true,
      groupIndex: 2,
      group: 8
    },
    {
      id: "rt_examination_number",
      visable: true,
      export: true,
      groupIndex: 0,
      group: 9
    },
    {
      id: "rt_examination_date",
      visable: true,
      export: true,
      groupIndex: 1,
      group: 9
    },
    {
      id: "rt_examination_result",
      visable: true,
      export: true,
      groupIndex: 2,
      group: 9
    },
    {
      id: "pt_examination_number",
      visable: true,
      export: true,
      groupIndex: 0,
      group: 10
    },
    {
      id: "pt_examination_date",
      visable: true,
      export: true,
      groupIndex: 1,
      group: 10
    },
    {
      id: "pt_examination_result",
      visable: true,
      export: true,
      groupIndex: 2,
      group: 10
    },
    {
      id: "ut_examination_number",
      visable: true,
      export: true,
      groupIndex: 0,
      group: 11
    },
    {
      id: "ut_examination_date",
      visable: true,
      export: true,
      groupIndex: 1,
      group: 11
    },
    {
      id: "ut_examination_result",
      visable: true,
      export: true,
      groupIndex: 2,
      group: 11
    },
    {
      id: "mt_examination_number",
      visable: true,
      export: true,
      groupIndex: 0,
      group: 12
    },
    {
      id: "mt_examination_date",
      visable: true,
      export: true,
      groupIndex: 1,
      group: 12
    },
    {
      id: "mt_examination_result",
      visable: true,
      export: true,
      groupIndex: 2,
      group: 12
    },
  ]
};
